export const MIN_DELAY = 500
